import React, { useState, useEffect, useRef } from "react";

const testimonials = [
  {
    name: "Koneru Chowdary",
    img: "https://plus.unsplash.com/premium_photo-1689568126014-06fea9d5d341?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cHJvZmlsZXxlbnwwfHwwfHx8MA%3D%3D",
    text: "It provided total privacy for our functions, world class hospitality standards, good family entertainment and a place for fun and frolic...",
    rating: 5,
    position: "Event Organizer"
  },
  {
    name: "Pooja Vora",
    img: "https://images.unsplash.com/photo-1532074205216-d0e1f4b87368?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fHByb2ZpbGV8ZW58MHx8MHx8fDA%3D",
    text: "They are professionals and understand their client's requirements well. We wish them best of luck for their new projects.",
    rating: 5,
    position: "Corporate Client"
  },
  {
    name: "Vinay Kumar",
    img: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fHByb2ZpbGV8ZW58MHx8MHx8fDA%3D",
    text: "We have organized a corporate event... Support from Nidhi at the front desk was very supportive. I wish them all the best.",
    rating: 5,
    position: "Business Executive"
  },
  {
    name: "Ankita Mehta",
    img: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8cHJvZmlsZXxlbnwwfHwwfHx8MA%3D%3D",
    text: "Amazing venue and hospitality! Our family had a great experience. The resort is clean, peaceful, and super fun for kids.",
    rating: 5,
    position: "Family Guest"
  },
  {
    name: "Vikku kumar",
    img: "https://images.unsplash.com/photo-1532074205216-d0e1f4b87368?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fHByb2ZpbGV8ZW58MHx8MHx8fDA%3D",
    text: "They are professionals and understand their client's requirements well. We wish them best of luck for their new projects.",
    rating: 5,
    position: "Corporate Head"
  },
  {
    name: "Sudhanshu kumar",
    img: "https://media.istockphoto.com/id/2194078950/photo/profile-picture-of-smiling-confident-arabic-businessman.webp?a=1&b=1&s=612x612&w=0&k=20&c=42Z7FDi1u5Ogevtd0xMUkTWM7hDzrre4YOlbHKvK_T8=",
    text: "We have organized a corporate event... Support from Nidhi at the front desk was very supportive. I wish them all the best.",
    rating: 5,
    position: "Business Executive"
  },
  {
    name: "Shubham kumar",
    img: "https://images.unsplash.com/photo-1505033575518-a36ea2ef75ae?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fHByb2ZpbGV8ZW58MHx8MHx8fDA%3D",
    text: "Amazing venue and hospitality! Our family had a great experience. The resort is clean, peaceful, and super fun for kids.",
    rating: 5,
    position: "Family Guest"
  },
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    if (!isAutoPlaying) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      return;
    }
    
    const startAutoPlay = () => {
      intervalRef.current = setInterval(() => {
        setIsTransitioning(true);
        setTimeout(() => {
          setCurrentIndex(prev => (prev + 1) % testimonials.length);
          setIsTransitioning(false);
        }, 500); // Match this with CSS transition duration
      }, 3000); // Change slide every 3 seconds
    };

    startAutoPlay();
    
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isAutoPlaying, testimonials.length]);

  const getVisibleTestimonials = () => {
    if (isMobile) {
      return [testimonials[currentIndex]];
    }
    
    const result = [];
    const visibleCount = 3;
    for (let i = 0; i < visibleCount; i++) {
      const index = (currentIndex + i) % testimonials.length;
      result.push(testimonials[index]);
    }
    return result;
  };

  const nextTestimonial = () => {
    if (isTransitioning) return;
    
    setIsAutoPlaying(false);
    setIsTransitioning(true);
    
    setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % testimonials.length);
      setIsTransitioning(false);
      
      // Restart autoplay after a delay
      setTimeout(() => setIsAutoPlaying(true), 5000);
    }, 500);
  };

  const prevTestimonial = () => {
    if (isTransitioning) return;
    
    setIsAutoPlaying(false);
    setIsTransitioning(true);
    
    setTimeout(() => {
      setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
      setIsTransitioning(false);
      
      // Restart autoplay after a delay
      setTimeout(() => setIsAutoPlaying(true), 5000);
    }, 500);
  };

  const goToTestimonial = (index) => {
    if (isTransitioning || index === currentIndex) return;
    
    setIsAutoPlaying(false);
    setIsTransitioning(true);
    
    setTimeout(() => {
      setCurrentIndex(index);
      setIsTransitioning(false);
      
      // Restart autoplay after a delay
      setTimeout(() => setIsAutoPlaying(true), 5000);
    }, 500);
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <span key={i} className={`star ${i < rating ? 'filled' : ''}`}>
        ★
      </span>
    ));
  };

  return (
    <section className="testimonials-section">
      <style jsx>{`
        .testimonials-section {
          position: relative;
          min-height: 100vh;
          background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
          padding: 80px 20px;
          overflow: hidden;
        }

        .background-decoration {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          z-index: 1;
        }

        .decoration-circle {
          position: absolute;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(20px);
          animation: float 6s ease-in-out infinite;
        }

        .decoration-circle-1 {
          width: 200px;
          height: 200px;
          top: 10%;
          right: 10%;
          animation-delay: 0s;
        }

        .decoration-circle-2 {
          width: 150px;
          height: 150px;
          bottom: 20%;
          left: 5%;
          animation-delay: -3s;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(180deg); }
        }

        .testimonials-container {
          position: relative;
          max-width: 1200px;
          margin: 0 auto;
          z-index: 2;
        }

        .testimonials-header {
          text-align: center;
          margin-bottom: 60px;
        }

        .quote-icon {
          display: inline-block;
          width: 60px;
          height: 60px;
          background: rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(10px);
          border-radius: 50%;
          line-height: 60px;
          font-size: 24px;
          color: white;
          margin-bottom: 20px;
          animation: pulse 2s infinite;
        }

        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }

        .testimonials-header h2 {
          font-size: 48px;
          font-weight: 700;
          background: linear-gradient(45deg, #ffffff, #f0f0f0);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 16px;
          text-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }

        .subtitle {
          font-size: 18px;
          color: rgba(255, 255, 255, 0.8);
          max-width: 600px;
          margin: 0 auto;
          line-height: 1.6;
        }

        .testimonials-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 40px;
          // overflow: hidden;
        }

        .nav-arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          border: none;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          font-size: 24px;
          color: #28a745;
          cursor: pointer;
          transition: all 0.3s ease;
          z-index: 10;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        }

        .nav-arrow:hover {
          background: white;
          transform: translateY(-50%) scale(1.1);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
        }

        .nav-arrow-left {
          left: 0px;
        }

        .nav-arrow-right {
          right: 0px;
        }

        .testimonial-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
          max-width: 1000px;
          margin: 0 auto;
          position: relative;
        }

        .testimonial-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          border-radius: 20px;
          padding: 40px 30px;
          position: relative;
          transition: all 0.5s ease;
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
          min-height: 300px;
          opacity: 1;
          transform: translateX(0);
        }

        .testimonial-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
        }

        .testimonial-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(45deg, #28a745, #20c997);
          opacity: 0;
          border-radius: 20px;
          transition: opacity 0.3s ease;
          z-index: -1;
        }

        .testimonial-card:hover::before {
          opacity: 0.05;
        }

        .testimonial-card.slide-out {
          opacity: 0;
          transform: translateX(-100%);
        }

        .testimonial-card.slide-in {
          opacity: 0;
          transform: translateX(100%);
        }

        .quote-accent {
          position: absolute;
          top: -10px;
          left: 30px;
          width: 40px;
          height: 40px;
          background: linear-gradient(45deg, #667eea, #764ba2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 18px;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
        }

        .rating {
          display: flex;
          align-items: center;
          gap: 4px;
          margin-bottom: 20px;
        }

        .star {
          font-size: 18px;
          color: #ddd;
          transition: color 0.3s ease;
        }

        .star.filled {
          color: #ffd700;
          text-shadow: 0 0 10px rgba(255, 215, 0, 0.5);
        }

        .testimonial-text {
          font-size: 16px;
          line-height: 1.7;
          color: #444;
          margin-bottom: 30px;
          font-style: italic;
          position: relative;
        }

        .user-info {
          display: flex;
          align-items: center;
          gap: 15px;
        }

        .user-avatar {
          position: relative;
        }

        .user-avatar img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          object-fit: cover;
          border: 3px solid #28a745;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        }

        .status-indicator {
          position: absolute;
          bottom: 0;
          right: 0;
          width: 16px;
          height: 16px;
          background: #28a745;
          border-radius: 50%;
          border: 3px solid white;
          animation: pulse-status 2s infinite;
        }

        @keyframes pulse-status {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.1); }
        }

        .user-details {
          flex: 1;
        }

        .user-name {
          font-size: 18px;
          font-weight: 700;
          color: #333;
          margin-bottom: 4px;
        }

        .user-position {
          font-size: 14px;
          color: #28a745;
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .pagination-dots {
          display: flex;
          justify-content: center;
          gap: 12px;
          margin-bottom: 30px;
        }

        .dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.4);
          border: none;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .dot.active {
          background: white;
          transform: scale(1.2);
          box-shadow: 0 0 15px rgba(255, 255, 255, 0.6);
        }

        .dot:hover {
          background: rgba(255, 255, 255, 0.7);
          transform: scale(1.1);
        }

        .autoplay-control {
          text-align: center;
        }

        .autoplay-btn {
          background: rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.3);
          color: white;
          padding: 10px 20px;
          border-radius: 25px;
          cursor: pointer;
          transition: all 0.3s ease;
          font-size: 14px;
        }

        .autoplay-btn:hover {
          background: rgba(255, 255, 255, 0.3);
          transform: translateY(-2px);
        }

        @media screen and (max-width: 768px) {
          .testimonials-section {
            padding: 60px 15px;
          }

          .testimonials-header h2 {
            font-size: 32px;
          }

          .subtitle {
            font-size: 16px;
          }

          .testimonial-grid {
            grid-template-columns: 1fr;
            gap: 20px;
          }

          .testimonial-card {
            padding: 30px 20px;
          }

          .nav-arrow {
            width: 40px;
            height: 40px;
            font-size: 20px;
          }

          .nav-arrow-left {
            left: -20px;
          }

          .nav-arrow-right {
            right: -20px;
          }

          .decoration-circle {
            display: none;
          }
        }

        @media screen and (max-width: 480px) {
          .testimonials-section {
            padding: 40px 10px;
          }

          .testimonials-header h2 {
            font-size: 28px;
          }

          .testimonial-card {
            padding: 25px 15px;
          }

          .nav-arrow {
            display: none;
          }

          .testimonials-wrapper {
            margin-bottom: 30px;
          }
        }
      `}</style>

      <div className="background-decoration">
        <div className="decoration-circle decoration-circle-1"></div>
        <div className="decoration-circle decoration-circle-2"></div>
      </div>

      <div className="testimonials-container">
        <div className="testimonials-header">
          <div className="quote-icon">❝</div>
          <h2>What Our Clients Say</h2>
          <p className="subtitle">Discover the experiences that make us proud to serve our community</p>
        </div>

        <div className="testimonials-wrapper">
          <button 
            className="nav-arrow nav-arrow-left"
            onClick={prevTestimonial}
            disabled={isTransitioning}
          >
            ‹
          </button>
          
          <div className="testimonial-grid">
            {getVisibleTestimonials().map((testimonial, index) => {
              let cardClass = "testimonial-card";
              if (isTransitioning && index === 0) {
                cardClass += " slide-out";
              } else if (isTransitioning && index === 2) {
                cardClass += " slide-in";
              }
              
              return (
                <div
                  key={`${testimonial.name}-${index}`}
                  className={cardClass}
                >
                  <div className="quote-accent">❝</div>
                  
                  <div className="rating">
                    {renderStars(testimonial.rating)}
                  </div>

                  <p className="testimonial-text">"{testimonial.text}"</p>

                  <div className="user-info">
                    <div className="user-avatar">
                      <img
                        src={testimonial.img}
                        alt={testimonial.name}
                      />
                      <div className="status-indicator"></div>
                    </div>
                    <div className="user-details">
                      <h4 className="user-name">{testimonial.name}</h4>
                      {/* <p className="user-position">{testimonial.position}</p> */}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <button 
            className="nav-arrow nav-arrow-right"
            onClick={nextTestimonial}
            disabled={isTransitioning}
          >
            ›
          </button>
        </div>

        <div className="pagination-dots">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goToTestimonial(index)}
              disabled={isTransitioning}
            ></button>
          ))}
        </div>

        {/* <div className="autoplay-control">
          <button
            className="autoplay-btn"
            onClick={() => setIsAutoPlaying(!isAutoPlaying)}
          >
            {isAutoPlaying ? '⏸️ Pause' : '▶️ Play'} Auto-scroll
          </button>
        </div> */}
      </div>
    </section>
  );
};

export default Testimonials;